import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, GetMethodResponse, ListMethodArg, ListMethodResponse, ModelClass, References } from '/imports/types';
import { validateBoolean, validateNumber, validateString } from '/imports/validators';
import { strings } from '/imports/strings';

export interface PrimeRate extends Doc {
  date: string;
  rate: number;
}
export type Model = PrimeRate;

export const PrimeRates = new Mongo.Collection<PrimeRate>('primeRates');

type Refs = References<Model>

export const modelClass: ModelClass<Model, Refs> = {
  collection: PrimeRates,
  editableFields: ['active', 'date', 'rate',
  ],
  fieldLimits: {
    'date': 64,
  },
  listMethod: DeclareMethod<ListMethodArg<PrimeRate>, ListMethodResponse<PrimeRate, Refs>>('listPrimeRates'),
  getMethod: DeclareMethod<string, GetMethodResponse<PrimeRate, Refs>>('getPrimeRate'),
  createMethod: DeclareMethod<Partial<PrimeRate>, string>('createPrimeRate'),
  updateMethod: DeclareMethod<Partial<PrimeRate>, string>('updatePrimeRate'),
  deleteMethod: DeclareMethod<string>('deletePrimeRate'),
  pathPrefix: '/prime-rates',
  asString: (document) => document.name || document._id,
  modelName: strings.PrimeRate(),
  pluralName: strings.PrimeRates(),
  /**
   * Builds a Mongo query matching prime rates by id or name substring.
   * @param search - free-text search term
   * @returns Mongo selector ({} when search is empty)
   */
  searchQuery: (search?: string) => {
    search = search?.trim();
    if (!search?.length) return {};
    return {
      $or: [
        { _id: search },
        { name: new RegExp(search, 'gi') },
      ]
    };
  },
  /**
   * Validates a prime rate's required fields.
   * @param primeRate - partial prime rate to validate
   * @returns map of field name to validation errors
   */
  validate: async (primeRate: Partial<PrimeRate>) => {
    const errors: { [key: string]: string[] } = {};
    validateBoolean(errors, primeRate, 'active');
    validateString(errors, primeRate, 'date', { required: true });
    validateNumber(errors, primeRate, 'rate', { required: true });
    return errors;
  },
};

Meteor.isServer && Meteor.startup(async () => {
  await PrimeRates.createIndexAsync({ date: 1 }, { unique: true });
});